import {makeActionCreator} from '../../core-utilities/redux';
import {ViewSwitcherDirection} from '../enums';


/** @type {Function|ReduxActionCreator<StateLoadErrorPayload>} */
export const stateLoadError = makeActionCreator('@@uiRouter', 'STATE_LOAD_ERROR');

/**
 * @typedef {Object} StateLoadErrorPayload
 * @property {Object} err
 * @property {RouterStateError} err.code
 * @property {String} [err.messageId]
 * @property {String} [err.fallback]
 */

/** @type {Function|ReduxActionCreator<AnimatedStateGoPayload>} */
export const animatedStateGo = makeActionCreator('@@uiRouter', 'ANIMATED_STATE_GO');

/** @type {Function|ReduxActionCreator<AnimatedStateGoToPayload>} */
export const stateGoForward = animatedStateGoWith(ViewSwitcherDirection.forward);

/** @type {Function|ReduxActionCreator<AnimatedStateGoToPayload>} */
export const stateGoBack = animatedStateGoWith(ViewSwitcherDirection.back);

/** @type {Function|ReduxActionCreator<AnimatedStateGoToPayload>} */
export const stateGoEnter = animatedStateGoWith(ViewSwitcherDirection.enter);

/** @type {Function|ReduxActionCreator<AnimatedStateGoToPayload>} */
export const stateGoExit = animatedStateGoWith(ViewSwitcherDirection.exit);

/** @type {Function|ReduxActionCreator<AnimatedStateGoToPayload>} */
export const stateGoSwap = animatedStateGoWith(ViewSwitcherDirection.swap);

function animatedStateGoWith(direction) {
  return payload => animatedStateGo({
    direction,
    ...payload,
  });
}

/**
 * @typedef {Object} AnimatedStateGoPayload
 * @property {String} state
 * @property {ViewSwitcherDirection} direction
 * @property {Object} [params]
 */

/**
 * @typedef {Object} AnimatedStateGoToPayload
 * @property {String} state
 * @property {Object} [params]
 */



// WEBPACK FOOTER //
// ./src/js/app/actions/router.js